import { render, staticRenderFns } from "./forwarder.vue?vue&type=template&id=3bb39955&scoped=true&"
import script from "./forwarder.vue?vue&type=script&lang=js&"
export * from "./forwarder.vue?vue&type=script&lang=js&"
import style0 from "./forwarder.vue?vue&type=style&index=0&id=3bb39955&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb39955",
  null
  
)

export default component.exports